import api from '@/lib/api/crate-core-api-client'

export type User = {
  id: number
  email: string
  username: string
  plan?: {
    id: number
    name: string
  }
  team?: {
    id: number
    name: string
    subscription?: {
      id: number
      plan?: {
        id: number
        name: string
        features: Array<{
          id: number
          name: string
          policy?: {
            id: number
            string: string
            statements: Array<{
              id: number
              statement: string
              type: 'file_extensions' | 'verticals' | 'tags' | 'ids' | 'level'
            }>
          }
        }>
        is_free: boolean
      }
    }
  }
  cohort?: string
  settings?: Record<string, any>
}

export const getUserProfile = async ({ signal }: { signal?: AbortSignal } = {}) => {
  const { data } = await api.get<User>('/me', { signal })
  return data
}

export const refreshToken = async (refreshToken: string, { signal }: { signal?: AbortSignal } = {}) => {
  const { data } = await api.post<{
    access_token: string
    refresh_token: string
  }>(
    '/auth/refresh-token',
    {
      refresh_token: refreshToken,
    },
    { signal }
  )
  return data
}

export type PushSubscription = {
  onesignal_id: string
  token: string
  platform: 'web'
  browser?: string
}

export const registerPushSubscription = async (
  subscription: PushSubscription,
  { signal }: { signal?: AbortSignal } = {}
) => {
  await api.post(
    '/push/subscriptions',
    {
      device_token: subscription.token,
      external_user_id: subscription.onesignal_id,
      platform: subscription.platform,
      browser: subscription.browser,
    },
    { signal }
  )
}

export const unregisterPushSubscription = async (deviceToken: string, { signal }: { signal?: AbortSignal } = {}) => {
  await api.delete('/push/subscriptions', { data: { device_token: deviceToken }, signal })
}
